// Whether the plan switcher is a feature for this build/tenant. The bootstrap
// resolve step short-circuits to `notApplicable` (→ Home, no socket call) when
// this is false, so a client without the plan switcher never calls
// resolve_plan_selection. Contract:
// https://everlong.atlassian.net/wiki/spaces/GEIS/pages/7495745645
//
// Hardcoded `true` — the plan switcher is a core Geisinger R1 feature, so the
// `notApplicable`-via-capability path is unreachable in any build we ship today
// and exists for the tenants that follow. Until one of them needs it, the
// server's `not_applicable` status is what actually exercises that route at
// runtime; the machine test covers the capability-off branch by mocking this
// module. Swap the body for a runtime feature-flag/entitlement lookup when a
// tenant needs to toggle it without a rebuild. Kept as a function (not a const)
// so it stays straightforward to mock.
export const isPlanSwitcherEnabled = (): boolean => true;
